module.exports = __webpack_public_path__ + "img/vipt.87e02a55.jpg";